import { getPropsForClickTracking } from "../../utils/tracking";
$ const { selected, expanded, itemPillData } = input;
import type { ItemConditionPillData, PricePillData } from "../../@types/mapviewxs";
export interface Input {
  expanded?: boolean;
  selected?: boolean;
  itemPillData: PricePillData | ItemConditionPillData;
  "on-filter-pill-click"?: () => void;
}

<div data-testid="map-filter-pill">
  <ebay-filter-chip
    variant="menu"
    data-testid="map-filter-pill-btn"
    on-click("emit", "filter-pill-click")
    expanded=expanded
    selected=selected
    ...getPropsForClickTracking(itemPillData.action?.trackingList)
  >
    <fe-textual-display model=itemPillData.label/>
  </ebay-filter-chip>
</div>
